import { jsx as m } from "react/jsx-runtime";
import * as l from "react";
import * as o from "@radix-ui/react-separator";
import { cn as p } from "../../../lib/utils.js";
const f = l.forwardRef(({ className: a, orientation: r = "horizontal", decorative: t = !0, ...e }, i) => m(o.Root, { ref: i, decorative: t, orientation: r, className: p("shrink-0 bg-neutral-300 dark:bg-neutral-600", r === "horizontal" ? "h-[2px] w-full" : "h-full w-[2px]", a), ...e }));
f.displayName = o.Root.displayName;
export {
  f as Separator
};
//# sourceMappingURL=Separator.js.map
